/* eslint-disable camelcase */
import { Client as ClientEntity, Account as AccountPlatform } from '@domain/platform/platform.types';

export enum ObjectSelectedEnum {
    Client = 'Client',
    Account = 'Account'
}
export interface AccountSelected extends AccountPlatform {
    selected: boolean;
    value: string;
    content_type: number;
    content_type_name: string;
    is_mocked?: boolean;
}

export interface ClientSelected extends Omit<ClientEntity, 'id'> {
    id: string | number;
    selected: boolean;
    value: string;
    is_mocked: boolean;
    content_type: number;
}

export interface ObjectSelected {
   account_selected: AccountSelected;
   client_selected: ClientSelected;
   loadingObjectSelected: boolean;
   isAccountSelected: boolean;
}

export enum ObjectSelectedTypes {
    client = 'client',
    account = 'account'
}
